import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import api from "../Service/api";
import "./Purchases.css";
import UniversalInvoicePrint from "./UniversalInvoicePrint";

function RevertStock() {

  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [vendorList, setVendorList] = useState([]);
  const [generalDiscount, setGeneralDiscount] = useState(0);
  const [rent, setRent] = useState("");
  const [description, setDescription] = useState("");
  const printRef = useRef();
  const [canPrint, setCanPrint] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [printInvoice, setPrintInvoice] = useState(null);
  const [invoiceImage, setInvoiceImage] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedVendorBalance, setSelectedVendorBalance] = useState(null);

  const [loadingProducts, setLoadingProducts] = useState(true);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingVendors, setLoadingVendors] = useState(true);

  const [returnDate, setReturnDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });

  const [gstPercentage, setGstPercentage] = useState(0);

  useEffect(() => {
    const phone = localStorage.getItem("userPhone");
    if (!phone) return;
    api.get(`/authentication/userData/${phone}`)
      .then(res => setLoggedInUser(res.data.additionalDetail))
      .catch(console.error);
  }, []);

  const refreshVendorList = async () => {
    try {
      const res = await api.get("/product/getAll");
      if (res.data.code === 1) {
        setVendorList(res.data.additionalDetail);
      }
    } catch (err) {
      console.error("Error refreshing vendor list", err);
    }
  };

  const handleVendorChange = (e) => {
    const name = e.target.value;
    setVendorName(name);
    const vendor = vendorList.find(v => v.vendorName === name);
    if (vendor && vendor.currentBalance !== undefined) {
      setSelectedVendorBalance(vendor.currentBalance);
    } else {
      setSelectedVendorBalance(null);
    }
  };

  const handleFileChange = (e) => {
    setInvoiceImage(e.target.files[0]);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Invoice-${invoiceNumber}`,
  });

  const handlePrintClick = () => {
    if (!printInvoice) {
      alert("No invoice data to print");
      return;
    }
    handlePrint();
  };

  const [products, setProducts] = useState([{
    productName: '',
    category: '',
    quantity: '',
    price: '',
    size: '',
    ktae: '',
    gram: '',
    boxSize: '',
    particular: '',
    length: ''
  }]);

  const showWeightLabel = products.some(p => {
    const cat = (p.category || "").toLowerCase();
    return cat === "reel" || cat === "tota";
  });
  const [productList, setProductList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  let grandTotal = products.reduce((sum, p) => sum + (parseFloat(p.calculatedTotal) || 0), 0);
  if (rent) grandTotal += parseFloat(rent);
  if (generalDiscount) grandTotal -= parseFloat(generalDiscount);

  let totalBeforeGst = grandTotal;
  let gstAmount = (grandTotal * gstPercentage) / 100;
  let finalGrandTotal = parseFloat(grandTotal) + parseFloat(gstAmount);

  finalGrandTotal = finalGrandTotal.toFixed(2);
  gstAmount = gstAmount.toFixed(2);
  totalBeforeGst = parseFloat(totalBeforeGst).toFixed(2);

  const totalReturnedQuantity = products.reduce((sum, p) => {
    const qty = parseFloat(p.quantity);
    return sum + (isNaN(qty) ? 0 : qty);
  }, 0);

  const refreshProductList = async () => {
    setLoadingProducts(true);
    try {
      const res = await api.get("/product/names-prices");
      if (res.data.code === 1) {
        setProductList(res.data.additionalDetail);
      }
    } catch (err) {
      console.error("Error refreshing product list", err);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    api.get("/product/names-prices")
      .then(res => {
        if (res.data.code === 1) setProductList(res.data.additionalDetail);
      })
      .catch(console.error)
      .finally(() => setLoadingProducts(false));
  }, []);

  useEffect(() => {
    api.get("/api/category/getCategories")
      .then(res => {
        if (res.data.code === 1) setCategoryList(res.data.additionalDetail);
      })
      .catch(console.error)
      .finally(() => setLoadingCategories(false));
  }, []);

  useEffect(() => {
    api.get("/product/getAll")
      .then(res => {
        if (res.data.code === 1) setVendorList(res.data.additionalDetail);
      })
      .catch(console.error)
      .finally(() => setLoadingVendors(false));
  }, []);

  useEffect(() => {
    api.get("/product/purchaseStockRevert/next-invoice")
      .then(res => setInvoiceNumber(res.data.nextInvoice))
      .catch(console.error);
  }, []);

  const getFilteredStock = (stockByWeight, category, sizeValue, lengthValue) => {
    if (!stockByWeight) return null;
    
    const filtered = {};
    const lowerCat = category?.toLowerCase();
    
    for (const display in stockByWeight) {
      const qty = stockByWeight[display];
      if (lowerCat === 'roll') {
        if (sizeValue) {
          const displaySize = display.match(/^(\d+(?:\.\d+)?)/);
          if (displaySize && parseFloat(displaySize[1]) === parseFloat(sizeValue)) {
            filtered[display] = qty;
          }
        } else {
          filtered[display] = qty;
        }
      } else if (lowerCat === 'reel' || lowerCat === 'tota') {
        if (lengthValue) {
          const lengthMatch = display.match(/\|\s*(\d+(?:\.\d+)?)m/);
          if (lengthMatch && parseFloat(lengthMatch[1]) === parseFloat(lengthValue)) {
            filtered[display] = qty;
          }
        } else {
          filtered[display] = qty;
        }
      } else {
        filtered[display] = qty;
      }
    }
    
    return filtered;
  };

  useEffect(() => {
  const handleWheel = (e) => {
    if (e.target.type === 'number') {
      e.preventDefault();
    }
  };
  const container = document.querySelector('.purchase-table-container');
  if (container) {
    container.addEventListener('wheel', handleWheel, { passive: false });
  }
  return () => {
    if (container) {
      container.removeEventListener('wheel', handleWheel);
    }
  };
}, []);

  const handleChange = (index, field, value) => {
    const updated = [...products];
    updated[index][field] = value;

    if (field === "productName") {
      const found = productList.find(
        p => p.productName.toLowerCase() === value.toLowerCase()
      );
      if (found) {
        updated[index].price = found.purchasePrice;
        updated[index].category = found.category;
        const categoryName = (found.category || "").toLowerCase();
        if (categoryName === 'roll' && found.size) {
          updated[index].size = found.size;
        }
      }
    }

    const currentCategory = (updated[index].category || "").toLowerCase();
    if (field === "quantity" && (currentCategory === "reel" || currentCategory === "tota")) {
      const weightValue = parseFloat(value) || 0;
      updated[index].size = weightValue;
    }

    if (field === "category") {
      const foundCat = categoryList.find(
        c => c.categoryName.toLowerCase() === value.toLowerCase()
      );
      updated[index].category = foundCat ? foundCat.categoryName : value;
    }

    if (field === "category") {
      const newCategory = value.toLowerCase();
      if (newCategory !== 'box') {
        updated[index].boxSize = '';
        updated[index].particular = '';
      }
      if (newCategory !== 'packet') {
        updated[index].ktae = '';
        updated[index].gram = '';
      }
      if (!['packet', 'roll', 'reel', 'tota', 'box'].includes(newCategory)) {
        updated[index].size = '';
      }
      if (newCategory !== 'reel' && newCategory !== 'tota') {
        updated[index].length = '';
      }
    }

    const category = (updated[index].category || "").toLowerCase();
    const quantity = parseFloat(updated[index].quantity) || 0;
    const price = parseFloat(updated[index].price) || 0;
    const size = parseFloat(updated[index].size) || 0;
    const ktae = parseFloat(updated[index].ktae) || 0;
    const gram = parseFloat(updated[index].gram) || 0;

    let total = 0;
    if (category === "packet") {
      total = ((price * ktae * size * gram) / 15500) * quantity;
    } else if (category === "roll") {
      total = quantity * size * price;
    } else if (category === "reel" || category === "tota") {
      total = quantity * price;
    } else {
      total = quantity * price;
    }
    updated[index].calculatedTotal = total.toFixed(2);
    setProducts(updated);
  };

  const addRow = () => {
    setProducts([...products, {
      productName: '', category: '', quantity: '',
      price: '', size: '', ktae: '', gram: '', boxSize: '', particular: '', length: ''
    }]);
  };

  const removeAllRows = () => {
    setProducts([{
      productName: '', category: '', quantity: '',
      price: '', size: '', ktae: '', gram: '', boxSize: '', particular: '', length: ''
    }]);
  };
  const removeRow = (index) => {
  setProducts(prev => prev.filter((_, i) => i !== index));
};

  const validateForm = () => {
    if (!vendorName || vendorName.trim() === "") {
      alert("Vendor name is required");
      return false;
    }
    if (!products || products.length === 0) {
      alert("At least one product is required");
      return false;
    }
    for (let i = 0; i < products.length; i++) {
      const p = products[i];
      const row = i + 1;
      if (!p.productName || p.productName.trim() === "") {
        alert(`Product name is required (Row ${row})`);
        return false;
      }
      if (!p.category || p.category.trim() === "") {
        alert(`Category is required (Row ${row})`);
        return false;
      }
      const category = p.category.toLowerCase();
      if (category === "reel" || category === "tota") {
        if (!p.quantity || Number(p.quantity) <= 0) {
          alert(`Weight (Quantity) is required for ${category} (Row ${row})`);
          return false;
        }
        if (!p.length || Number(p.length) <= 0) {
          alert(`Length is required for ${category} (Row ${row})`);
          return false;
        }
      }
      if (category === "packet") {
        if (!p.size || Number(p.size) <= 0) {
          alert(`Size is required for packet (Row ${row})`);
          return false;
        }
        if (!p.ktae || Number(p.ktae) <= 0) {
          alert(`Ktae is required for packet (Row ${row})`);
          return false;
        }
        if (!p.gram || Number(p.gram) <= 0) {
          alert(`Gram is required for packet (Row ${row})`);
          return false;
        }
      }
      if (category === "roll") {
        if (!p.size || Number(p.size) <= 0) {
          alert(`Size is required for ${category} (Row ${row})`);
          return false;
        }
      }
      if (category === "box") {
        if (!p.boxSize || p.boxSize.trim() === "") {
          alert(`Box Size is required for box (Row ${row})`);
          return false;
        }
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);
    setIsSubmitting(true);

    const payload = {
      invoiceNumber: parseInt(invoiceNumber),
      vendorName: vendorName,
      invoiceDiscount: parseFloat(generalDiscount) || 0,
      invoiceRent: parseFloat(rent) || 0,
      description: description,
      returnDate: returnDate,
      gstPercentage: parseFloat(gstPercentage) || 0,
      stock: products.map(p => {
        const category = p.category.toLowerCase();
        const baseProduct = {
          productName: p.productName,
          category: p.category,
          quantity: parseFloat(p.quantity) || 0,
          price: parseFloat(p.price) || 0,
          generalDiscount: parseFloat(p.generalDiscount) || 0,
          rent: parseFloat(p.rent) || 0
        };
        if (category === "packet") {
          return {
            ...baseProduct,
            size: parseFloat(p.size) || 0,
            ktae: parseFloat(p.ktae) || 0,
            gram: parseFloat(p.gram) || 0,
            boxSize: null,
            particular: null
          };
        } else if (category === "roll") {
          return {
            ...baseProduct,
            size: parseFloat(p.size) || 0,
            ktae: null,
              gram: null,
            boxSize: null,
            particular: null
          };
        } else if (category === "reel" || category === "tota") {
          return {
            ...baseProduct,
            size: parseFloat(p.quantity) || 0,
            length: parseFloat(p.length) || 0,
            ktae: null,
              gram: null,
            boxSize: null,
            particular: p.particular || ""
          };
        } else if (category === "box") {
          return {
            ...baseProduct,
            size: 0,
            ktae: null,
              gram: null,
            boxSize: p.boxSize || "",
            particular: p.particular || ""
          };
        } else {
          return {
            ...baseProduct,
            size: 0,
            ktae: null,
              gram: null,
            boxSize: null,
            particular: p.particular || ""
          };
        }
      })
    };

    try {
      const formData = new FormData();
      formData.append("request", JSON.stringify(payload));
      if (invoiceImage) formData.append("invoiceImage", invoiceImage);
      const res = await api.post("/product/returnStock", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      alert(res.data.additionalDetail || "Stock returned successfully");
      setCanPrint(true);

      const invoiceSnapshot = {
        invoiceNumber,
        vendorName,
        products: JSON.parse(JSON.stringify(products)),
        invoiceDiscount: generalDiscount,
        invoiceRent: rent,
        grandTotal: finalGrandTotal,
        gstPercentage: gstPercentage,
        gstAmount: gstAmount,
        totalBeforeGst: totalBeforeGst,
        user: loggedInUser,
        returnDate: returnDate
      };
      setPrintInvoice(invoiceSnapshot);

      removeAllRows();
      setProducts([{ productName: '', category: '', quantity: '', price: '', size: '', ktae: '', gram: '', boxSize: '', particular: '', length: '' }]);
      setVendorName("");
      setSelectedVendorBalance(null);
      setInvoiceNumber("");
      setRent("");
      setGeneralDiscount(0);
      setGstPercentage(0);
      setDescription("");
      setInvoiceImage(null);
      setReturnDate(new Date().toISOString().split('T')[0]);

      const next = await api.get("/product/purchaseStockRevert/next-invoice");
      setInvoiceNumber(next.data.nextInvoice);
      await refreshProductList();
      await refreshVendorList();
    } catch (err) {
      alert("Return failed");
      console.error(err);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const categories = products.map(p => (p.category || "").toLowerCase());
  const showPacketColumns = categories.includes("packet");
  const showRollColumns = categories.some(c => ["roll"].includes(c));
  const showBoxColumns = categories.includes("box");
  const showParticularColumn = categories.some(c => !["roll", "packet", "box"].includes(c));
  const showLengthColumn = categories.some(c => c === "reel" || c === "tota");
  // Show Size column if ANY product needs it (packet, roll, or reel/tota)
  const showSizeColumn = showPacketColumns || showRollColumns || showLengthColumn;

  const isInitialLoading = loadingProducts || loadingCategories || loadingVendors;

  if (isInitialLoading) {
    return React.createElement('div', { className: "purchase-table-container", style: { textAlign: 'center', padding: '50px' } },
      React.createElement('div', { style: { fontSize: '18px', color: '#0a8938' } }, 'Loading data...'),
      React.createElement('div', null, 'Please wait while we load products, categories, and vendors.')
    );
  }

  const renderStockInfo = (selectedProduct, productName, category, enteredSize, enteredLength) => {
    if (!selectedProduct || !productName) return null;
    
    const cat = (selectedProduct.category || "").toLowerCase();
    const isReelTota = cat === 'reel' || cat === 'tota';
    const isRollCat = cat === 'roll';
    const isPacketCat = cat === 'packet';
    
    let stockData = null;
    let hasStock = false;
    
    if ((isReelTota || isRollCat) && selectedProduct.stockByWeight) {
      stockData = getFilteredStock(selectedProduct.stockByWeight, cat, enteredSize, enteredLength);
      hasStock = stockData && Object.values(stockData).some(qty => qty > 0);
    } else if (isPacketCat && selectedProduct.packetStockByVariant) {
      stockData = selectedProduct.packetStockByVariant;
      hasStock = stockData && Object.values(stockData).some(qty => qty > 0);
    }
    
    if (!stockData || Object.keys(stockData).length === 0 || !hasStock) {
      return React.createElement('div', { style: { color: '#ff4444', backgroundColor: '#ffebee', padding: '6px 8px', borderRadius: '4px', marginTop: '4px', border: '1px solid #ff4444', fontSize: '11px' } },
        React.createElement('strong', null, '⚠️ No stock available'),
        (enteredSize || enteredLength) ? ` for ${enteredSize || enteredLength}` : ''
      );
    }
    
    const stockEntries = Object.entries(stockData).filter(([_, qty]) => qty > 0);
    
    return React.createElement('div', { style: { color: '#0a8938', backgroundColor: '#f8f9fa', padding: '6px 8px', borderRadius: '4px', marginTop: '4px', border: '1px solid #0a8938', fontSize: '11px' } },
      React.createElement('strong', { style: { fontSize: '10px', display: 'block', marginBottom: '4px' } }, '📊 Available Stock:'),
      React.createElement('div', { style: { display: 'flex', flexWrap: 'wrap', gap: '8px' } },
        stockEntries.map(([display, qty]) => 
          React.createElement('span', { key: display, style: { backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '12px', fontSize: '10px', fontWeight: 'bold' } },
            `${display}: `, React.createElement('span', { style: { color: '#2e7d32' } }, qty)
          )
        )
      )
    );
  };

  const elements = [];

  // Header section
  elements.push(React.createElement('div', { key: 'header', className: "purchase-table-container" },
    React.createElement('h2', { className: "page-title", style: { color: "#0a8938" } }, "Purchase Return Details"),
    
    React.createElement('div', { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px", marginBottom: "20px" } },
      React.createElement('div', null,
        React.createElement('label', { style: { fontWeight: "bold" } }, "Invoice #"),
        React.createElement('input', { type: "text", value: invoiceNumber, readOnly: true, className: "read-only-input" })
      ),
      React.createElement('div', null,
        React.createElement('label', { style: { fontWeight: "bold" } }, "Return Date"),
        React.createElement('input', { type: "date", value: returnDate, onChange: e => setReturnDate(e.target.value), className: "read-only-input", max: new Date().toISOString().split('T')[0] })
      ),
      React.createElement('div', null,
        React.createElement('label', { style: { fontWeight: "bold" } }, "Vendor Name"),
        React.createElement('input', { type: "text", list: "vendorNames", value: vendorName, onChange: handleVendorChange, placeholder: "Enter Vendor Name", className: "read-only-input" }),
        React.createElement('datalist', { id: "vendorNames" },
          vendorList.map((v, i) => React.createElement('option', { key: i, value: v.vendorName }, `${v.vendorName} ${v.currentBalance !== undefined ? `(Balance: ${v.currentBalance})` : ''}`))
        ),
        selectedVendorBalance !== null && React.createElement('div', { style: { fontSize: '12px', color: '#0a8938', marginTop: '5px' } }, `Current Balance: Rs ${selectedVendorBalance.toFixed(2)}`)
      )
    )
  ));

  // Table section
  const tableRows = [];
  
  products.forEach((product, idx) => {
    const category = product.category ? product.category.toLowerCase() : "";
    const selectedProduct = productList.find(p => p.productName === product.productName);
    const isPacket = category === "packet";
    const isReelOrTota = category === "reel" || category === "tota";
    const isRoll = category === "roll";
    
    const filteredStock = selectedProduct && (isReelOrTota || isRoll) ? getFilteredStock(selectedProduct.stockByWeight, product.category, product.size, product.length) : null;
    const hasStock = filteredStock && Object.values(filteredStock).some(qty => qty > 0);
    
    tableRows.push(
      React.createElement('tr', { key: idx },
        React.createElement('td', { style: { position: 'relative' } },
          React.createElement('input', {
            list: `products-${idx}`,
            value: product.productName,
            onChange: e => handleChange(idx, "productName", e.target.value),
            className: "read-only-input",
            placeholder: "Enter Product Name",
            style: {
              borderColor: (selectedProduct && !hasStock && product.productName) ? '#ff4444' : '',
              backgroundColor: (selectedProduct && !hasStock && product.productName) ? '#fff0f0' : ''
            }
          }),
          React.createElement('datalist', { id: `products-${idx}` },
            productList.map((p, i) => {
              const pCatLower = (p.category || "").toLowerCase();
              const isPReelOrTotaOrRoll = pCatLower === 'reel' || pCatLower === 'tota' || pCatLower === 'roll';
              const isPPacket = pCatLower === 'packet';
              
              if (isPReelOrTotaOrRoll && p.stockByWeight && Object.keys(p.stockByWeight).length > 0) {
                const nonZero = Object.entries(p.stockByWeight).filter(([_, qty]) => qty > 0);
                if (nonZero.length > 0) {
                  return React.createElement('option', { key: i, value: p.productName }, `${p.productName} [${nonZero.map(([display, qty]) => `${display}: ${qty}`).join(', ')}]`);
                } else {
                  return React.createElement('option', { key: i, value: p.productName }, `${p.productName} (Out of Stock)`);
                }
              } else if (isPPacket && p.packetStockByVariant && Object.keys(p.packetStockByVariant).length > 0) {
                const nonZero = Object.entries(p.packetStockByVariant).filter(([_, qty]) => qty > 0);
                if (nonZero.length > 0) {
                  return React.createElement('option', { key: i, value: p.productName }, `${p.productName} [${nonZero.map(([variant, qty]) => `${variant}: ${qty}`).join(', ')}]`);
                } else {
                  return React.createElement('option', { key: i, value: p.productName }, `${p.productName} (Out of Stock)`);
                }
              } else {
                return React.createElement('option', { key: i, value: p.productName }, `${p.productName}${p.stockQuantity !== undefined ? ` (Stock: ${p.stockQuantity})` : ''}${p.category === 'roll' && p.size ? ` [Size: ${p.size}]` : ''}`);
              }
            })
          ),
          renderStockInfo(selectedProduct, product.productName, product.category, product.size, product.length),
          isReelOrTota && (!product.quantity || parseFloat(product.quantity) <= 0) && product.productName && React.createElement('div', { style: { fontSize: '11px', color: '#ff9800', marginTop: '2px' } }, '⚡ Enter weight in kg in the Quantity column'),
          isRoll && (!product.quantity || parseFloat(product.quantity) <= 0) && product.productName && React.createElement('div', { style: { fontSize: '11px', color: '#ff9800', marginTop: '2px' } }, '⚡ Enter quantity (rolls) in the Quantity column'),
          isReelOrTota && (!product.length || parseFloat(product.length) <= 0) && product.productName && React.createElement('div', { style: { fontSize: '11px', color: '#ff9800', marginTop: '2px' } }, '⚡ Length is required (e.g., meters)'),
          isRoll && !product.size && product.productName && React.createElement('div', { style: { fontSize: '11px', color: '#ff4444', marginTop: '2px' } }, '⚠️ Size is required for roll products')
        ),
        React.createElement('td', null,
          React.createElement('input', { list: `categories-${idx}`, value: product.category, onChange: e => handleChange(idx, "category", e.target.value), className: "read-only-input" }),
          React.createElement('datalist', { id: `categories-${idx}` },
            Array.isArray(categoryList) && categoryList.map((c, i) => React.createElement('option', { key: i, value: c.categoryName }))
          )
        ),
        React.createElement('td', null,
          React.createElement('input', { type: "number", value: product.quantity, onChange: e => handleChange(idx, "quantity", e.target.value), className: "read-only-input", placeholder: isReelOrTota ? "Weight in kg" : (isRoll ? "Quantity (rolls)" : "Quantity"), step: isReelOrTota ? "1" : "0.01" })
        ),
        React.createElement('td', null,
          React.createElement('input', { type: "number", value: product.price, onChange: e => handleChange(idx, "price", e.target.value), className: "read-only-input" })
        ),
        // SINGLE Size column - shows size for packet/roll and length for reel/tota
        showSizeColumn && React.createElement('td', { key: 'size-col' },
          (isPacket || isRoll) ? 
            React.createElement('input', { type: "number", value: product.size || "", onChange: e => handleChange(idx, "size", e.target.value), className: "read-only-input", placeholder: isRoll ? "Size (e.g., 18)" : "Size", style: { borderColor: (isRoll && !product.size && product.productName) ? '#ff4444' : '' } }) :
            isReelOrTota ?
              React.createElement('input', { type: "number", step: "any", value: product.length || "", onChange: e => handleChange(idx, "length", e.target.value), className: "read-only-input", placeholder: "Length (m)", style: { borderColor: (!product.length && product.productName) ? '#ff4444' : '' } }) :
              React.createElement('input', { type: "text", value: "", className: "read-only-input", disabled: true, style: { backgroundColor: '#f0f0f0' }, placeholder: "N/A" })
        ),
        showPacketColumns && React.createElement(React.Fragment, { key: 'packet-cols' },
          React.createElement('td', null, isPacket ? React.createElement('input', { type: "number", value: product.ktae || "", onChange: e => handleChange(idx, "ktae", e.target.value), className: "read-only-input", placeholder: "Ktae" }) : React.createElement('input', { type: "text", value: "", className: "read-only-input", disabled: true, style: { backgroundColor: '#f0f0f0' }, placeholder: "N/A" })),
          React.createElement('td', null, isPacket ? React.createElement('input', { type: "number", value: product.gram || "", onChange: e => handleChange(idx, "gram", e.target.value), className: "read-only-input", placeholder: "Gram" }) : React.createElement('input', { type: "text", value: "", className: "read-only-input", disabled: true, style: { backgroundColor: '#f0f0f0' }, placeholder: "N/A" }))
        ),
        showBoxColumns && React.createElement('td', { key: 'box-col' },
          category === "box" ? React.createElement('input', { type: "text", value: product.boxSize || "", onChange: e => handleChange(idx, "boxSize", e.target.value), className: "read-only-input", placeholder: "Box Size" }) : React.createElement('input', { type: "text", value: "", className: "read-only-input", disabled: true, style: { backgroundColor: '#f0f0f0' }, placeholder: "N/A" })
        ),
        showParticularColumn && React.createElement('td', { key: 'particular-col' },
          (category !== 'roll' && category !== 'packet') ? React.createElement('input', { type: "text", value: product.particular || "", onChange: e => handleChange(idx, "particular", e.target.value), className: "read-only-input", placeholder: "Particular" }) : React.createElement('input', { type: "text", value: "", className: "read-only-input", disabled: true, style: { backgroundColor: '#f0f0f0' }, placeholder: "N/A" })
        ),
        React.createElement('td', null,
      React.createElement('button', {
        onClick: () => removeRow(idx),
        className: "remove-row-btn",
        title: "Remove this row"
      }, '✕')
    )
      )
      
    );
  });

  elements.push(
    React.createElement('div', { key: 'table', className: "table-scroll-wrapper" },
      React.createElement('table', { className: "purchase-table" },
        React.createElement('thead', null,
          React.createElement('tr', null,
            React.createElement('th', null, 'Product Name'),
            React.createElement('th', null, 'Category'),
            React.createElement('th', null, showWeightLabel ? "Weight (kg)" : "Returned Quantity"),
            React.createElement('th', null, 'Rate'),
            // SINGLE Size column header - shown if packet, roll, or reel/tota products exist
            showSizeColumn && React.createElement('th', { key: 'size-header' }, 'Size'),
            showPacketColumns && React.createElement(React.Fragment, { key: 'packet-headers' },
              React.createElement('th', null, 'Ktae'),
              React.createElement('th', null, 'Gram')
            ),
            showBoxColumns && React.createElement('th', null, 'Box Size'),
            showParticularColumn && React.createElement('th', null, 'Particular'),
                React.createElement('th', null, 'Action')

          )
        ),
        React.createElement('tbody', null, tableRows)
      )
    )
  );

  // Footer sections
  elements.push(
    React.createElement('div', { key: 'discount-gst-rent', style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px", marginTop: "20px" } },
      React.createElement('div', null,
        React.createElement('label', { style: { fontWeight: "bold" } }, "Discount"),
        React.createElement('input', { type: "number", value: generalDiscount, onChange: e => setGeneralDiscount(parseFloat(e.target.value) || 0), className: "read-only-input" })
      ),
      React.createElement('div', null,
        React.createElement('label', { style: { fontWeight: "bold" } }, "GST %"),
        React.createElement('input', { type: "number", value: gstPercentage, onChange: e => setGstPercentage(parseFloat(e.target.value) || 0), className: "read-only-input", min: "0", max: "100", step: "0.1" })
      ),
      React.createElement('div', null,
        React.createElement('label', { style: { fontWeight: "bold" } }, "Rent"),
        React.createElement('input', { type: "number", value: rent, onChange: e => setRent(parseFloat(e.target.value) || 0), className: "read-only-input" })
      )
    )
  );

  if (gstPercentage > 0) {
    elements.push(
      React.createElement('div', { key: 'gst-breakdown', style: { marginTop: "10px", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e9ecef", fontSize: "14px" } },
        React.createElement('div', { style: { display: "flex", gap: "20px", justifyContent: "center" } },
          React.createElement('span', null, React.createElement('strong', null, "Subtotal:"), " Rs ", totalBeforeGst),
          React.createElement('span', null, React.createElement('strong', null, `GST (${gstPercentage}%):`), " Rs ", gstAmount),
          React.createElement('span', null, React.createElement('strong', null, "Total after GST:"), " Rs ", (parseFloat(totalBeforeGst) + parseFloat(gstAmount)).toFixed(2))
        )
      )
    );
  }

  elements.push(
    React.createElement('div', { key: 'image', style: { marginTop: "20px" } },
      React.createElement('label', { style: { fontWeight: "bold", display: "block", marginBottom: "5px" } }, "Invoice Image (optional)"),
      React.createElement('div', { style: { border: "2px dashed #0a8938", padding: "20px", borderRadius: "8px", textAlign: "center", cursor: "pointer", backgroundColor: "#f9f9f9", color: "#555", width: "100%", boxSizing: "border-box" }, onClick: () => document.getElementById("invoiceImage").click() },
        invoiceImage ? invoiceImage.name : "Click or Drag to Upload Invoice Image",
        React.createElement('input', { id: "invoiceImage", type: "file", accept: "image/*", style: { display: "none" }, onChange: handleFileChange })
      )
    ),
    React.createElement('div', { key: 'description', style: { marginTop: "20px" } },
      React.createElement('label', { style: { fontWeight: "bold" } }, "Description"),
      React.createElement('input', { type: "text", value: description, onChange: e => setDescription(e.target.value), placeholder: "Enter Description", className: "read-only-input" })
    )
  );

  if (totalReturnedQuantity > 0) {
    elements.push(
      React.createElement('div', { key: 'total-qty', style: { marginTop: "10px", textAlign: "right", fontSize: "16px", fontWeight: "500", color: "#0a8938" } },
        `Total Returned Quantity: ${totalReturnedQuantity} ${showWeightLabel ? "kg" : "units"}`
      )
    );
  }

  elements.push(
    React.createElement('div', { key: 'grand-total', style: { marginTop: "20px", textAlign: "right", fontSize: "20px", fontWeight: "bold", color: "#0c6303" } },
      `Amount Receivable: Rs ${finalGrandTotal}`,
      gstPercentage > 0 && React.createElement('div', { style: { fontSize: "14px", color: "#666", marginTop: "5px" } }, `(Subtotal: Rs ${totalBeforeGst} + GST: Rs ${gstAmount})`)
    ),
    React.createElement('div', { key: 'buttons', className: "table-actions", style: { marginTop: "20px", display: "flex", gap: "10px" } },
      React.createElement('button', { onClick: removeAllRows, className: "remove-btn" }, "Remove All"),
      React.createElement('button', { onClick: handleSubmit, className: "save-btn", disabled: isSubmitting, style: { opacity: isSubmitting ? 0.6 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' } }, isSubmitting ? 'Saving...' : 'Save All'),
      React.createElement('button', { onClick: addRow, className: "add-btn" }, "Add Product"),
      React.createElement('button', { onClick: handlePrintClick, className: "print-btn", disabled: !canPrint }, "Print")
    ),
    React.createElement('div', { key: 'print', style: { position: "absolute", top: "-9999px" } },
      React.createElement(UniversalInvoicePrint, { ref: printRef, invoice: printInvoice, type: "purchaseReturn" })
    )
  );

  return React.createElement('div', { className: "purchase-table-container" }, elements);
}

export default RevertStock;